import { PERMISSION_LEVEL } from "@constants/permissionLevel";
import BillObjectLink from "@legacy/bills/components/BillObjectLink";
import Banner from "@legacy/core/components/Banner";
import LineItemListDisplayGroup from "@legacy/core/components/LineItemListDisplayGroup";
import Spinner from "@legacy/core/components/Spinner";
import PDFDownloadDialog from "@legacy/pricebook/components/PDFDownloadDialog";
import { AccessCheck } from "@particles/index";
import { Component, Fragment } from "react";
import ButtonGroup from "../../core/buttons/ButtonGroup";
import ButtonGroupRow from "../../core/buttons/ButtonGroupRow";
import UniversalButton from "../../core/buttons/UniversalButton";
import AttachmentHorizontalDisplay from "../../core/components/AttachmentHorizontalDisplay";
import EmailDisplay from "../../core/components/EmailDisplay";
import PhoneNumberDisplay from "../../core/components/PhoneNumberDisplay";
import BasicDisplayField from "../../core/fields/BasicDisplayField";
import LinkedObjectsDisplayField from "../../core/fields/LinkedObjectsDisplayField";
import { convertToKebabCase, currencyFormatterForServiceCompany, formatCurrencyForServiceCompany, formatLocalTime } from "../../core/utils/utils";
import EstimateObjectLink from "../../estimates/components/EstimateObjectLink";
import InvoiceObjectLink from "../../invoices/components/InvoiceObjectLink";
import JobObjectLink from "../../jobs/components/JobObjectLink";
import PurchaseOrderFeedAccordion from "../components/PurchaseOrderFeedAccordion";
import { getPurchaseOrderShippingPreference, getPurchaseOrderStatusBarLabel, getPurchaseOrderTrackingDetails } from "../utils/utils";


class PurchaseOrderDetailsCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPDFDialogOpen: false,
        };
    }

    componentDidMount() {
        // Return to the previous scroll
        document.querySelector(".main").scrollTo(0, this.props.returnScroll || 0)
    }

    handlePDFDownload = (selectedObjects, isPublicVersion) => {
        let url = window.PUBLIC_PDF_URL;
        const includePurchaseOrder = selectedObjects?.includes("Purchase Order") ? "true" : "false";

        if (selectedObjects?.length === 0 || selectedObjects === undefined && !isPublicVersion) {
            location.assign(url);
        } else {
            url = `${window.PUBLIC_PDF_URL}?include_purchase_order=${includePurchaseOrder}&public_version=${isPublicVersion ? "true" : "false"}`;
            location.assign(url);
        }

        this.setState({ isPDFDialogOpen: false });
    };

    renderButtons = () => {
    const { purchaseOrder, associatedEstimates, associatedJobs, associatedInvoices, childBills, requestAction, switchToSecondaryForm, submitting, errors, carrierAccountID } = this.props

        const handlePDFDialog = () => {
            this.setState({ isPDFDialogOpen: !this.state.isPDFDialogOpen })
        };

        if (submitting) {
            return (
                <div className="data-panel__action-feedback">
                    <Spinner centered={true} />
                </div>
            )
        }
        else {
            if (window.USING_PUBLIC_URL === true) {
                if (purchaseOrder.status_label === "Sent") {
                    return (
                        <ButtonGroup>
                            <ButtonGroupRow>
                                <UniversalButton type="primary" text="Acknowledge Order" handler={event => requestAction("PURCHASE_ORDER_ACKNOWLEDGE")} />
                            </ButtonGroupRow>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else if (purchaseOrder.status_label === "Acknowledged") {
                    return (
                        <ButtonGroup>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="primary" text="Mark as Shipped" handler={event => requestAction("PURCHASE_ORDER_SHIP")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else if (purchaseOrder.status_label === "In Transit") {
                    return (
                        <ButtonGroup>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Update Shipping Details" handler={event => requestAction("PURCHASE_ORDER_UPDATE_SHIPPING")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else {
                    return (
                        <ButtonGroup>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
            }
            else {
                if (purchaseOrder.status_label === "Draft") {
                    return (
                        <ButtonGroup>
                            <AccessCheck permissions={{
                                purchase_orders_create_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton
                                        type="primary"
                                        text={window.CURRENT_USER?.permissions.purchase_orders_edit_permission === PERMISSION_LEVEL.FULL ? "Create and Send" : "Create"}
                                        handler={event => requestAction("PURCHASE_ORDER_CREATE")}
                                    />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                                <AccessCheck permissions={{
                                    purchase_orders_edit_permission: PERMISSION_LEVEL.RESTRICTED
                                }}>
                                    <UniversalButton type="secondary" text="Edit Draft" handler={event => requestAction("PURCHASE_ORDER_EDIT")} />
                                </AccessCheck>
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else if (purchaseOrder.status_label === "Unsent") {
                    return (
                        <ButtonGroup>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="primary" text="Send Order" handler={event => requestAction("PURCHASE_ORDER_SEND")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Revise Order" handler={event => requestAction("PURCHASE_ORDER_EDIT")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                                <AccessCheck permissions={{
                                    purchase_orders_delete_permission: PERMISSION_LEVEL.RESTRICTED
                                }}>
                                    <UniversalButton type="danger" text="Mark Cancelled" handler={event => requestAction("PURCHASE_ORDER_CANCEL")} />
                                </AccessCheck>
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else if (purchaseOrder.status_label === "Sent") {
                    return (
                        <ButtonGroup>
                            <ButtonGroupRow>
                                <AccessCheck permissions={{
                                    purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                                }}>
                                    <UniversalButton type="primary" text="Mark as Acknowledged" handler={event => requestAction("PURCHASE_ORDER_ACKNOWLEDGE")} />
                                </AccessCheck>
                            </ButtonGroupRow>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Mark as Shipped" handler={event => requestAction("PURCHASE_ORDER_SHIP")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Mark as Delivered" handler={event => requestAction("PURCHASE_ORDER_MARK_AS_DELIVERED")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Mark as Stocked" handler={event => requestAction("PURCHASE_ORDER_MARK_AS_STOCKED")} />
                                </ButtonGroupRow>
                            </AccessCheck>

                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Revise Order" handler={event => requestAction("PURCHASE_ORDER_EDIT")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Resend Order" handler={event => requestAction("PURCHASE_ORDER_SEND")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                                <AccessCheck permissions={{
                                    purchase_orders_delete_permission: PERMISSION_LEVEL.RESTRICTED
                                }}>
                                    <UniversalButton type="danger" text="Mark Cancelled" handler={event => requestAction("PURCHASE_ORDER_CANCEL")} />
                                </AccessCheck>
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else if (purchaseOrder.status_label === "Acknowledged") {
                    return (
                        <ButtonGroup>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="primary" text="Mark as Shipped" handler={event => requestAction("PURCHASE_ORDER_SHIP")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Mark as Delivered" handler={event => requestAction("PURCHASE_ORDER_MARK_AS_DELIVERED")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Mark as Stocked" handler={event => requestAction("PURCHASE_ORDER_MARK_AS_STOCKED")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Revise Order" handler={event => requestAction("PURCHASE_ORDER_EDIT")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else if (purchaseOrder.status_label === "In Transit") {
                    return (
                        <ButtonGroup>
                            <ButtonGroupRow>
                                <UniversalButton type="primary" text="Mark as Delivered" handler={event => requestAction("PURCHASE_ORDER_MARK_AS_DELIVERED")} />
                            </ButtonGroupRow>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Mark as Stocked" handler={event => requestAction("PURCHASE_ORDER_MARK_AS_STOCKED")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Update Shipping Details" handler={event => requestAction("PURCHASE_ORDER_UPDATE_SHIPPING")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Revise Order" handler={event => requestAction("PURCHASE_ORDER_EDIT")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else if (purchaseOrder.status_label === "Unstocked") {
                    return (
                        <ButtonGroup>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="primary" text="Mark as Stocked" handler={event => requestAction("PURCHASE_ORDER_MARK_AS_STOCKED")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Update Shipping Details" handler={event => requestAction("PURCHASE_ORDER_UPDATE_SHIPPING")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Revise Order" handler={event => requestAction("PURCHASE_ORDER_EDIT")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else if (purchaseOrder.status_label === "Unpaid") {
                    return (
                        <ButtonGroup>
                            <AccessCheck permissions={{
                                bills_create_permission: PERMISSION_LEVEL.RESTRICTED
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="primary" text="Create Bill" handler={event => requestAction("PURCHASE_ORDER_CONVERT_BILL")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type={window.CURRENT_USER?.permissions.bills_create_permission < PERMISSION_LEVEL.RESTRICTED ? "primary" : "secondary"} text="Mark as Fully Paid" handler={event => requestAction("PURCHASE_ORDER_MARK_AS_PAID")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Revise Order" handler={event => requestAction("PURCHASE_ORDER_EDIT")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else if (purchaseOrder.status_label === "Paid") {
                    return (
                        <ButtonGroup>
                            <AccessCheck permissions={{
                                purchase_orders_edit_permission: PERMISSION_LEVEL.FULL
                            }}>
                                <ButtonGroupRow>
                                    <UniversalButton type="secondary" text="Revise Order" handler={event => requestAction("PURCHASE_ORDER_EDIT")} />
                                </ButtonGroupRow>
                            </AccessCheck>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
                else if (purchaseOrder.status_label === "Cancelled") {
                    return (
                        <ButtonGroup>
                            <ButtonGroupRow>
                                <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            </ButtonGroupRow>
                        </ButtonGroup>
                    )
                }
            }
        }
    }

    renderLastViewed = (lastViewed, preferredTimezone) => {
        const { localDateTimeString } = formatLocalTime(lastViewed, preferredTimezone, false, true, false, true)
        return localDateTimeString
    }

    render() {
        const { purchaseOrder, associatedEstimates, associatedJobs, associatedInvoices, childBills, requestAction, switchToSecondaryForm, submitting, errors, carrierAccountID } = this.props
        const { subtotal } = purchaseOrder

        return (
            <Fragment>
                <div id="purchase_order_details_react_wrapper">
                    <div className="data-panel-container">
                        <div className={`data-panel-status-bar purchase-orders-${convertToKebabCase(purchaseOrder.status_label)}`} aria-label="Status"><span>{getPurchaseOrderStatusBarLabel(purchaseOrder)}{window.USING_PUBLIC_URL === true && " Purchase Order"}</span></div>
                        <div className="data-panel with-status-bar" aria-label="Purchase Order Details">
                            {
                                purchaseOrder.service_company.logo && (
                                    <div className="data-panel__logo" aria-hidden="true">
                                        <div className="data-panel__logo__frame">
                                            <img src={purchaseOrder.service_company.logo} alt="Logo" />
                                        </div>
                                    </div>
                                )
                            }
                            <div className="data-panel__form" aria-label="Purchase Order Details">
                                <div className="data-panel__form__field" aria-label="Purchase Order Purchasing Vendor">
                                    <span className="data-panel__form__field__label" aria-hidden="true">Purchasing Vendor</span>
                                    <div className="data-panel__form__field__display-list" aria-label="Purchasing Vendor">
                                        <div className="data-panel__form__field__display-list__object purchase-order-contact-card" aria-label="Purchasing Vendor">
                                            <p>
                                                <strong>{purchaseOrder.vendor.name}</strong><br />
                                                <span>{purchaseOrder.vendor.billing_address_formatted_multiline}</span><br />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {
                                    purchaseOrder.billing_vendor && (
                                        <div className="data-panel__form__field" aria-label="Purchase Order Billing Vendor">
                                            <span className="data-panel__form__field__label" aria-hidden="true">Billing Vendor</span>
                                            <div className="data-panel__form__field__display-list" aria-label="Billing Vendor">
                                                <div className="data-panel__form__field__display-list__object purchase-order-contact-card" aria-label="Billing Vendor">
                                                    <p>
                                                        <strong>{purchaseOrder.billing_vendor.name}</strong><br />
                                                        <span>{purchaseOrder.billing_vendor.billing_address_formatted_multiline}</span><br />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                <div className="data-panel__form__field" aria-label="Purchase Order Bill To">
                                    <span className="data-panel__form__field__label" aria-hidden="true">Bill To</span>
                                    <div className="data-panel__form__field__display-list" aria-label="Bill To">
                                        <div className="data-panel__form__field__display-list__object invoice-contact-card" aria-label="Bill To">
                                            <p>
                                                <strong>{purchaseOrder.service_company.name}</strong><br />
                                                {purchaseOrder.vendor.account_id && <Fragment><span>Account ID: {purchaseOrder.vendor.account_id}</span><br /></Fragment>}
                                                <span>{purchaseOrder.service_company.physical_address_formatted_multiline}</span><br />
                                                {purchaseOrder.service_company.phone && <Fragment><span><PhoneNumberDisplay phone={purchaseOrder.service_company.phone} phoneExtension={purchaseOrder.service_company.phone_extension} hyperlink={true} /></span><br /></Fragment>}
                                                {purchaseOrder.service_company.email && <Fragment><span><EmailDisplay email={purchaseOrder.service_company.email} hyperlink={true} /></span><br /></Fragment>}
                                                {purchaseOrder.service_company.contractor_license_number && <Fragment><span>License #{purchaseOrder.service_company.contractor_license_number}</span><br /></Fragment>}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="data-panel__form__field" aria-label="Purchase Order Ship To">
                                    <span className="data-panel__form__field__label" aria-hidden="true">Ship To</span>
                                    <div className="data-panel__form__field__display-list" aria-label="Ship To">
                                        <div className="data-panel__form__field__display-list__object invoice-contact-card" aria-label="Ship To">
                                            <p>
                                                <strong>{purchaseOrder.service_company.name}</strong><br />
                                                <span>Re: Roopairs PO ID: {purchaseOrder.custom_id ? purchaseOrder.custom_id : purchaseOrder.id}</span><br />
                                                <span>{purchaseOrder.inventory_location.physical_address_formatted_multiline}</span><br />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {!(window.USING_PUBLIC_URL === true) && (
                                    <BasicDisplayField
                                        fieldName="inventory_location"
                                        fieldLabel="Inventory Location"
                                        fieldValue={purchaseOrder.inventory_location.name}
                                    ></BasicDisplayField>
                                )}
                                <BasicDisplayField
                                    fieldName="id"
                                    fieldLabel="Roopairs Purchase Order ID"
                                    fieldValue={purchaseOrder.custom_id ? purchaseOrder.custom_id : purchaseOrder.id}
                                ></BasicDisplayField>
                                {
                                    purchaseOrder.vendor_internal_id && (
                                        <BasicDisplayField
                                            fieldName="vendor_internal_id"
                                            fieldLabel="Purchasing Vendor PO ID"
                                            fieldValue={purchaseOrder.vendor_internal_id}
                                        ></BasicDisplayField>
                                    )
                                }
                                <BasicDisplayField
                                    fieldName="date_issued"
                                    fieldLabel="Date Issued"
                                    fieldValue={formatLocalTime(purchaseOrder.date_issued, purchaseOrder.service_company.preferred_timezone, true, false, false, true).localDateString}
                                ></BasicDisplayField>
                                {
                                    purchaseOrder.estimated_arrival_time && ["Pending", "Open", "In Transit"].includes(purchaseOrder.state_label) && (
                                        <BasicDisplayField
                                            fieldName="estimated_arrival_time"
                                            fieldLabel="Estimated Arrival Time"
                                            fieldValue={formatLocalTime(purchaseOrder.estimated_arrival_time, purchaseOrder.service_company.preferred_timezone, false, true, false, true).localDateTimeString}
                                        ></BasicDisplayField>
                                    )
                                }
                                <BasicDisplayField
                                    fieldName="shipping"
                                    fieldLabel={["Pending", "Open"].includes(purchaseOrder.state_label) ? "Shipping Preference" : "Shipping"}
                                    fieldValue={getPurchaseOrderShippingPreference(purchaseOrder)}
                                ></BasicDisplayField>
                                {
                                    carrierAccountID && (
                                        <BasicDisplayField
                                            fieldName="carrier_account_id"
                                            fieldLabel="Carrier Account ID"
                                            fieldValue={carrierAccountID}
                                        ></BasicDisplayField>
                                    )
                                }
                                {
                                    !["Pending", "Open"].includes(purchaseOrder.state_label) && (
                                        <BasicDisplayField
                                            fieldName="tracking_number"
                                            fieldLabel="Tracking Number"
                                            fieldValue={getPurchaseOrderTrackingDetails(purchaseOrder)}
                                        ></BasicDisplayField>
                                    )
                                }
                                {
                                    !window.USING_PUBLIC_URL && purchaseOrder.labels.length !==0 && (
                                        <BasicDisplayField
                                            fieldName="labels"
                                            fieldLabel={<Fragment>Labels <span className="text-optional">(Only Visible to You)</span></Fragment>}
                                            fieldValue={purchaseOrder.labels.map((label, index) => <span key={`label_${index}`} className="data-tag">{label.name}</span>)}
                                        ></BasicDisplayField>
                                    )
                                }
                                <BasicDisplayField
                                    fieldName="payment_terms"
                                    fieldLabel="Payment Terms"
                                    fieldValue={purchaseOrder.vendor.payment_terms !== 0 ? `Net ${purchaseOrder.vendor.payment_terms}` : "Same Day"}
                                ></BasicDisplayField>
                                {
                                    !window.USING_PUBLIC_URL && purchaseOrder.last_viewed !== null && (
                                        <BasicDisplayField
                                            fieldName="last_viewed"
                                            fieldLabel="Last Seen"
                                            fieldValue={this.renderLastViewed(purchaseOrder.last_viewed, purchaseOrder.service_company.preferred_timezone)}
                                        ></BasicDisplayField>
                                    )
                                }
                                {
                                    purchaseOrder.last_status_transition_time !== null && (
                                        <BasicDisplayField
                                            fieldName="last_status_transition_time"
                                            fieldLabel={`${["Sent", "Acknowledged"].includes(purchaseOrder.status_label) ? purchaseOrder.status_label : purchaseOrder.state_label} On`}
                                            fieldValue={this.renderLastViewed(purchaseOrder.last_status_transition_time, purchaseOrder.service_company.preferred_timezone)}
                                        ></BasicDisplayField>
                                    )
                                }
                                {
                                    purchaseOrder.last_status_transition_message !== "" && (
                                        <BasicDisplayField
                                            fieldName="last_status_transition_message"
                                            fieldLabel={`${["Sent", "Acknowledged"].includes(purchaseOrder.status_label) ? purchaseOrder.status_label : purchaseOrder.state_label} Message`}
                                            fieldValue={purchaseOrder.last_status_transition_message}
                                        ></BasicDisplayField>
                                    )
                                }
                                {!(window.USING_PUBLIC_URL === true) && (
                                    <BasicDisplayField
                                        fieldName="last_modified_at"
                                        fieldLabel="Last Modified"
                                        fieldValue={this.renderLastViewed(purchaseOrder.last_modified_at, purchaseOrder.service_company.preferred_timezone)}
                                    ></BasicDisplayField>
                                )}
                                <LineItemListDisplayGroup
                                    object={purchaseOrder}
                                    formatCurrencyValue={currencyFormatterForServiceCompany(purchaseOrder.service_company)}
                                    isPurchaseOrderLineItem={true}
                                    showPricebookPartDisplay={true}
                                ></LineItemListDisplayGroup>
                                {
                                    purchaseOrder.comments !== "" && (
                                        <BasicDisplayField
                                            fieldName="comments"
                                            fieldLabel="Notes to Vendor"
                                            fieldValue={purchaseOrder.comments}
                                        ></BasicDisplayField>
                                    )
                                }
                                {
                                    purchaseOrder.attachments.length !== 0 && purchaseOrder.service_company.feature_file_uploads_enabled &&  (
                                        <BasicDisplayField
                                            fieldName="attachments"
                                            fieldLabel="Attachments"
                                            fieldValue={<AttachmentHorizontalDisplay
                                                attachments={purchaseOrder.attachments}
                                                attachmentsEndpoint={DjangoUrls["purchase-orders:api-purchase-orders-attachments-list"](window.MARKETPLACE_ENTITY_SLUG, purchaseOrder.id)}
                                                isPublic={window.USING_PUBLIC_URL === true}
                                                    />}
                                            >
                                        </BasicDisplayField>)
                                }
                                {
                                    purchaseOrder.service_company.purchase_order_fine_print !== "" && (
                                        <BasicDisplayField
                                            fieldName="purchase_order_fine_print"
                                            fieldLabel={purchaseOrder.service_company.purchase_order_fine_print_label}
                                            fieldValue={purchaseOrder.service_company.purchase_order_fine_print}
                                        ></BasicDisplayField>
                                    )
                                }
                                {
                                    !(window.USING_PUBLIC_URL === true) && associatedEstimates.length !== 0 && (
                                        <AccessCheck
                                            entitlements={["entitlement_estimates_enabled"]}
                                            permissions={{
                                                estimates_list_permission: PERMISSION_LEVEL.RESTRICTED
                                            }}
                                        >
                                            <LinkedObjectsDisplayField
                                                fieldName="associated_estimates_"
                                                fieldLabel="Associated Estimates"
                                                objectComponentList={associatedEstimates.map((estimate, index) => (
                                                    <EstimateObjectLink
                                                        key={`associated_estimates_${index}`}
                                                        estimate={estimate}
                                                        destination={DjangoUrls["estimates:estimates-detail"](window.MARKETPLACE_ENTITY_SLUG, estimate.id)}
                                                        disabled={window.CURRENT_USER?.permissions.estimates_view_permission < PERMISSION_LEVEL.FULL}
                                                    />
                                                ))}
                                            ></LinkedObjectsDisplayField>
                                        </AccessCheck>
                                    )
                                }
                                {
                                    !(window.USING_PUBLIC_URL === true) && associatedJobs.length !== 0 && (
                                        <AccessCheck
                                            entitlements={["entitlement_jobs_enabled"]}
                                            permissions={{
                                                jobs_list_permission: PERMISSION_LEVEL.RESTRICTED
                                            }}
                                        >
                                            <LinkedObjectsDisplayField
                                                fieldName="associated_jobs_"
                                                fieldLabel="Associated Jobs"
                                                objectComponentList={associatedJobs.map((associatedJob, index) => (
                                                    <JobObjectLink
                                                        key={`associated_jobs_${index}`}
                                                        job={associatedJob}
                                                        destination={DjangoUrls["jobs:jobs-detail"](window.MARKETPLACE_ENTITY_SLUG, associatedJob.id)}
                                                        disabled={window.CURRENT_USER?.permissions.jobs_view_permission < PERMISSION_LEVEL.FULL}
                                                    />
                                                ))}
                                            ></LinkedObjectsDisplayField>
                                        </AccessCheck>
                                    )
                                }
                                {
                                    !(window.USING_PUBLIC_URL === true) && associatedInvoices.length !== 0 && (
                                        <AccessCheck
                                            entitlements={["entitlement_invoices_enabled"]}
                                            permissions={{
                                                invoices_list_permission: PERMISSION_LEVEL.RESTRICTED
                                            }}
                                        >
                                            <LinkedObjectsDisplayField
                                                fieldName="associated_invoices_"
                                                fieldLabel="Associated Invoices"
                                                objectComponentList={associatedInvoices.map((invoice, index) => (
                                                    <InvoiceObjectLink
                                                        key={`associated_invoices_${index}`}
                                                        invoice={invoice}
                                                        destination={DjangoUrls["invoices:invoices-detail"](window.MARKETPLACE_ENTITY_SLUG, invoice.id)}
                                                        disabled={window.CURRENT_USER?.permissions.invoices_view_permission < PERMISSION_LEVEL.FULL}
                                                    />
                                                ))}
                                            ></LinkedObjectsDisplayField>
                                        </AccessCheck>
                                    )
                                }
                                {
                                    !(window.USING_PUBLIC_URL === true) && childBills.length !== 0 && (
                                        <AccessCheck entitlements={["entitlement_bills_enabled"]} permissions={{
                                            bills_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}>
                                            <LinkedObjectsDisplayField
                                                fieldName="bills"
                                                fieldLabel="Bills"
                                                objectComponentList={childBills.map((bill, index) =>
                                                    <BillObjectLink
                                                        key={`child_bills_${index}`}
                                                        bill={bill}
                                                        destination={DjangoUrls["bills:bills-detail"](window.MARKETPLACE_ENTITY_SLUG, bill.id)}
                                                        disabled={!(window.USING_PUBLIC_URL === true) && window.CURRENT_USER?.permissions.bills_view_permission < PERMISSION_LEVEL.FULL}
                                                    />
                                                )}
                                            ></LinkedObjectsDisplayField>
                                        </AccessCheck>
                                    )
                                }
                            </div>
                            <div className="data-panel__form data-panel__data-summary amount-summary" aria-label="Amount Summary">
                                <hr aria-hidden="true" />
                                <div className="data-panel__data-summary__row amount-summary__item amount-summary__item--subtotal" aria-label="Subtotal">
                                    <div className="data-panel__data-summary__data__label"><span>Expected Subtotal</span></div>
                                    <div className="data-panel__data-summary__data__value">{formatCurrencyForServiceCompany(subtotal, purchaseOrder.service_company)}</div>
                                </div>
                            </div>
                            {
                                Object.keys(errors).length !== 0 && (
                                    <Banner type="danger" text="This purchase order has errors and cannot be created. Please edit the draft to fix them." extraMargin={true} />
                                )
                            }
                            {this.renderButtons()}
                            <PDFDownloadDialog
                                isOpen={this.state.isPDFDialogOpen}
                                onOpenChange={(newValue) => this.setState({ isPDFDialogOpen: newValue })}
                                objects={[
                                    'Purchase Order',
                                ]}
                                onDownload={this.handlePDFDownload}
                                showToggle={purchaseOrder.service_company.slug === window.CURRENT_USER?.service_company?.slug}
                            />
                        </div>
                    </div>
                </div>
                {!(window.USING_PUBLIC_URL === true) &&
                    <div className="accordion-wrapper">
                        <AccessCheck permissions={{
                            purchase_orders_view_permission: PERMISSION_LEVEL.FULL
                        }}>
                            <PurchaseOrderFeedAccordion purchaseOrderID={purchaseOrder.id} />
                        </AccessCheck>
                    </div>
                }
                {window.USING_PUBLIC_URL === true &&
                    <div className="powered-by-panel">
                        <span>Powered By</span>
                        <img className="logo--grey" src={window.LOGOTYPE_URL} width="148px" alt="Roopairs"></img>
                    </div>
                }
            </Fragment>
        )
    }

}

export default PurchaseOrderDetailsCard;
